/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'loupe': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M19.724 18.262l-3.702-3.696c2.831-3.524 2.559-8.734-.67-11.935A8.947 8.947 0 008.992 0C6.584 0 4.349.943 2.634 2.63A8.928 8.928 0 000 8.984c0 2.406.944 4.64 2.633 6.352a8.947 8.947 0 006.36 2.63 9.04 9.04 0 005.614-1.959l3.7 3.696a.981.981 0 00.696.298.901.901 0 00.695-.298c.398-.422.398-1.042.026-1.44zm-3.726-9.304a6.953 6.953 0 01-6.979 6.971A6.951 6.951 0 012.04 8.958a6.953 6.953 0 016.979-6.971 6.951 6.951 0 016.979 6.97z" _fill="#213F6B" fill-rule="evenodd"/>'
  }
})
